<template>
  <v-app id="impAipoApp">
    <v-main>
      <v-container fluid>
      <v-form v-if="!results"  v-model="impAipoValid">
      <v-row>
          <v-col cols="6">
            <v-file-input v-model="aipo_file" id="myFile" ref="myFile" @change="onFileChange" show-size label="Choose the Airbnb payout CSV file" filled prepend-icon="mdi-application-import" accept=".csv" :rules="aipo_fileRules"></v-file-input>
          </v-col>
      </v-row>
      <v-row>
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="aipoImport" :disabled="!impAipoValid" >Import CSV file</v-btn>
          </v-col> 
      </v-row>
      </v-form>

      <v-row v-if="results" no-gutters>
        <v-card class="px-2">
          <v-simple-table dense>
                    <template v-slot:default>
          <tbody v-for="(aipoRecord,k1) in impAipo.aipo" :key="k1">
                          <tr>
                            <td> {{aipoRecord.aipo_type}} </td>
                            <td></td>
                            <td></td>
                            <td align="right">{{aipoRecord.aipo_paidout }}</td>
                            <td><v-chip :color=aipoRecord.aipo_kleur>{{aipoRecord.aipo_result}}</v-chip></td>
                          </tr>
                          <tr v-for="(aiprRecord,k2) in aipoRecord.aipr" :key="k2">
                            <td><span class="mx-2">{{aiprRecord.aipr_confirmationcode}}</span></td>
                            <td align="right">{{aiprRecord.aipr_amount}}</td>
                            <td><v-chip :color=aiprRecord.aipr_kleur>{{aiprRecord.aipr_result}}</v-chip></td>
                          </tr>  
                          <tr><td colspan=3>
                             </td>
                          </tr>  
                          
                        </tbody> 
             </template>
            </v-simple-table>
                        
        
        </v-card>
        </v-row>
    </v-container>
    </v-main>
    <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      results: false,
      impAipoValid: false,
      impAipo: {},
      url: null,
      src: null,
      aipo_file: null,
      aipo_fileRules: [
          v => !!v || "An CSV file is required"
      ]
    }  
  },
  methods: {
    onFileChange() {
      var deze = this;
      
      const file = deze.aipo_file;
      if (deze.aipo_file != null) {
          deze.url = URL.createObjectURL(file);
      
          let reader = new FileReader();
      
          reader.readAsDataURL(file);
          reader.onload = evt => {
              this.src = evt.target.result;
            }

          reader.onerror = evt => {
             console.error(evt);
          }  
      } else  {
         deze.url = null;
      }   
    },
     aipoImport() {
      this.impAipoValid = false;
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/inpt/airbnb/impAipo.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "impAipo"
          },
          impAipo: {
             aipo_file: this.src
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.impAipo = res.data.impAipo;
            this.impAipoValid = true;
            this.aipo_file = null;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};

</script> 
